import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useTranslation } from "react-i18next";

const LogOut = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { LogOut } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    fetch(`${apiUrl}/log-out`, {
      method: "POST",
      credentials: "include",
    })
      .then((response) => {
        if (response.ok) {
          LogOut();
          navigate("/");
        } else {
          throw new Error(t("logout.errors.failed"));
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la déconnexion:", error);
      });
  }, [LogOut, navigate, apiUrl, t]);

  return <div>{t("logout.message")}</div>;
};

export default LogOut;
